import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { createAndUpdateOffersServer, getOffersServer } from '../../../apis/offersApi'
import { getLocationsServer } from '../../../apis/locationApi'
import { offersScheme } from '../../../Validations/offersValidations'
// import {
//   createAndUpdateOffersServer,
//   getOffersServer
// } from '../../../apis/offersApi'
// import { offersScheme } from '../../../lib/validations/offersValidations'
// import { getLocationsServer } from '../../../apis/locationsApi'

export default function AddOffers () {
  const [loading, setLoading] = useState(false)
  const [editLoader, setEditLoader] = useState(false)
  const [locations, setLocations] = useState([])
  const [addOffersInitial, setAddOffersInitial] = useState({
    title: '',
    description: '',
    discount: '',
    subTitle: '',
    startDate: '',
    endDate: '',
    locationId: ''
  })
  const { id } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    if (id) {
      editOffers(id)
    }
    getLocations()
  }, [id])

  const editOffers = async id => {
    setEditLoader(false)
    try {
      const res = await getOffersServer(id)
      let result = res.result
      if (res.result) {
        setAddOffersInitial({
          title: res.result.title,
          description: res.result.description,
          discount: res.result.discount,
          subTitle: res.result.subTitle,
          startDate: formatDateTime(result.startDate),
          endDate: formatDateTime(result.endDate),
          locationId: res.result.locationId
        })
      }
    } catch (error) {
      console.error('Error fetching Offers:', error)
    } finally {
      setLoading(false)
    }
  }
  const getLocations = async () => {
    try {
      const res = await getLocationsServer()
      if (res?.result) {
        setLocations(res.result)
      }
    } catch (err) {
      console.error('Failed to fetch Locations:', err)
    }
  }
  const formik = useFormik({
    initialValues: addOffersInitial,
    enableReinitialize: true,
    validationSchema: offersScheme,
    onSubmit: async values => {
      try {
        setLoading(false)
        let res
        if (id) {
          values.id = id
          res = await createAndUpdateOffersServer(id, values)
          console.log(res)
        } else {
          res = await createAndUpdateOffersServer(null, values)
        }
        setLoading(false)
        formik.resetForm()
        navigate('/offers')
      } catch (error) {
        console.error('Error submitting form:', error)
        throw error
      }
    }
  })
  const backClick = () => {
    navigate('/offers')
  }
  const formatDateTime = (dateTimeStr) => {
    const date = new Date(dateTimeStr)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
  
    return `${year}-${month}-${day}T${hours}:${minutes}`
  }
  

  const getCurrentDateTime = () => {
    const now = new Date()
    let year = now.getFullYear()
    let month = String(now.getMonth() + 1).padStart(2, '0')
    let day = String(now.getDate()).padStart(2, '0')
    let hours = now.getHours()
    let minutes = now.getMinutes()

    minutes += 1 // Add 1 minute to prevent selecting the current time

    // Adjust hour if minutes exceed 59
    if (minutes >= 60) {
      minutes = 0
      hours += 1
    }

    // Adjust day if hours exceed 23 (midnight roll-over)
    if (hours >= 24) {
      hours = 0
      const nextDay = new Date(now)
      nextDay.setDate(now.getDate() + 1)
      year = nextDay.getFullYear()
      month = String(nextDay.getMonth() + 1).padStart(2, '0')
      day = String(nextDay.getDate()).padStart(2, '0')
    }

    hours = String(hours).padStart(2, '0')
    minutes = String(minutes).padStart(2, '0')

    return `${year}-${month}-${day}T${hours}:${minutes}`
  }

  return (
    <>
      <div className='main-wrapper'>
        <div className='page-wrapper'>
          <div className='content container-fluid'>
            {' '}
            <i
              className='fas fa-arrow-left'
              style={{ marginRight: '30px', fontSize: '20px' }}
              onClick={backClick}
            />
            <div className='my-3 p-3 bg-body rounded shadow-sm'>
              {editLoader ? (
                <div
                  className='d-flex justify-content-center align-items-center'
                  style={{ height: '50px', padding: '7px 30px' }}
                >
                  <div className='spinner-border' role='status'>
                    <span className='visually-hidden'>Loading...</span>
                  </div>
                </div>
              ) : (
                <form onSubmit={formik.handleSubmit} className='formMaxwidth'>
                  <div className='input-block mb-3'>
                    <label className='col-form-label'>
                      Title <span className='text-danger'>*</span>
                    </label>
                    <input
                      className='form-control'
                      type='text'
                      name='title'
                      value={formik.values.title}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.title && formik.touched.title && (
                      <span className='text-danger'>{formik.errors.title}</span>
                    )}
                  </div>
                  <div className='input-block mb-3'>
                    <label className='col-form-label'>
                      Description <span className='text-danger'>*</span>
                    </label>
                    <input
                      type='text'
                      className='form-control'
                      name='description'
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.description &&
                      formik.touched.description && (
                        <span className='text-danger'>
                          {formik.errors.description}
                        </span>
                      )}
                  </div>
                  <div className='input-block mb-3'>
                    <label className='col-form-label'>
                      SubTitle <span className='text-danger'>*</span>
                    </label>
                    <input
                      type='text'
                      className='form-control'
                      name='subTitle'
                      value={formik.values.subTitle}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.subTitle && formik.touched.subTitle && (
                      <span className='text-danger'>
                        {formik.errors.subTitle}
                      </span>
                    )}
                  </div>
                  <div className='input-block mb-3'>
                    <label className='col-form-label'>
                      discount <span className='text-danger'>*</span>
                    </label>
                    <input
                      type='text'
                      className='form-control'
                      name='discount'
                      value={formik.values.discount}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.discount && formik.touched.discount && (
                      <span className='text-danger'>
                        {formik.errors.discount}
                      </span>
                    )}
                  </div>
                  {/* <div className='input-block mb-3'>
                    <label className='col-form-label'>
                      SubTitle <span className='text-danger'>*</span>
                    </label>
                    <input
                      type='text'
                      className='form-control'
                      name='subTitle'
                      value={formik.values.subTitle}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.discount && formik.touched.discount && (
                      <span className='text-danger'>
                        {formik.errors.discount}
                      </span>
                    )}
                  </div> */}
                  <div className='mb-3'>
                    <label className='form-label'>
                      Start Date
                      <span className='text-danger'>*</span>
                    </label>
                    <input
                      className={`form-control ${
                        formik.touched.startDate && formik.errors.startDate
                          ? 'is-invalid'
                          : ''
                      }`}
                      type='datetime-local'
                      name='startDate'
                      value={formik.values.startDate}
                      min={getCurrentDateTime()}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />

                    {formik.touched.startDate && formik.errors.startDate && (
                      <div className='text-danger'>
                        {formik.errors.startDate}
                      </div>
                    )}
                  </div>

                  <div className='mb-3'>
                    <label className='form-label'>
                      End Date
                      <span className='text-danger'>*</span>
                    </label>
                    <input
                      className={`form-control ${
                        formik.touched.endDate && formik.errors.endDate
                          ? 'is-invalid'
                          : ''
                      }`}
                      type='datetime-local'
                      name='endDate'
                      value={formik.values.endDate}
                      min={formik.values.startDate || getCurrentDateTime()}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.endDate && formik.errors.endDate && (
                      <div className='text-danger'>{formik.errors.endDate}</div>
                    )}
                  </div>
                  <div className='input-block mb-3'>
                    <label className='col-form-label'>
                      Locations <span className='text-danger'>*</span>
                    </label>
                    <select
                      className='form-control'
                      name='locationId'
                      value={formik.values.locationId}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      <option value=''>Select Location</option>
                      {locations.map(cat => (
                        <option key={cat.id} value={cat.id}>
                          {cat.name}
                        </option>
                      ))}
                    </select>
                    {formik.errors.locationId && formik.touched.locationId && (
                      <span className='text-danger'>
                        {formik.errors.locationId}
                      </span>
                    )}
                  </div>

                  {/* <div className="input-block">
                    <input
                      className="form-control"
                      type="file"
                      name="image"
                      accept="image/*"
                      onChange={uploadFile}
                      onBlur={formik.handleBlur}
                      placeholder="Upload File"
                      style={{ width: "250px" }}
                    />
                    {formik.errors.image && formik.touched.image && (
                      <span className="text-danger">{formik.errors.image}</span>
                    )}
                    {formik.values.image && (
                      <img src={formik.values.image} width={300} />
                    )}
                  </div> */}
                  {loading ? (
                    <div
                      className='d-flex justify-content-center align-items-center'
                      style={{ height: '50px', padding: '7px 30px' }}
                    >
                      <div className='spinner-border' role='status'>
                        <span className='visually-hidden'>Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <button className='btn btn-primary' type='submit'>
                      {id ? 'Update' : 'Submit'}
                    </button>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
